import { Tooltip, TooltipTrigger } from "@artis/ui";
import { SidebarIconWrapper } from "../layout/SidebarIconWrapper";
import { prefetchGridSettings, useGridSettingsVisible } from "./hooks";
import { GridSettingsIcon } from "../icons";

export const ToggleGridSettingsButton = () => {
  const [isGridSettingsVisible, setIsGridSettingsVisible] = useGridSettingsVisible();
  const toggle = () => {
    setIsGridSettingsVisible(!isGridSettingsVisible);
  };

  return (
    <TooltipTrigger placement="right">
      <SidebarIconWrapper onMouseEnter={() => void prefetchGridSettings()}>
        <button
          type="button"
          onClick={toggle}
          data-testid="settings-button"
          className="w-full h-full flex items-center justify-center"
        >
          <GridSettingsIcon />
        </button>
      </SidebarIconWrapper>
      <Tooltip>Settings</Tooltip>
    </TooltipTrigger>
  );
};
